// React
import { useState, useEffect } from "react";

// Styled Components
import styled from "styled-components";

// Anchor
import * as anchor from "@project-serum/anchor";

// Components
import Background from "./Background/Background";
import Nav from "./Nav/Nav";
import Intro from "./Intro/Intro";
import InfoOne from "./InfoOne/InfoOne";
import Carousel from "./Carousel/Carousel";
import InfoTwo from "./InfoTwo/InfoTwo";

import Arena from "./Arena/Arena";

import InfoThree from "./InfoThree/InfoThree";
import InfoFour from "./InfoFour/InfoFour";
import InfoFive from "./InfoFive/InfoFive";
import Roadmap from "./Roadmap/Roadmap";
import Generate from "./Generate/Generate";
import Faq from "./Faq/Faq";
import Footer from "./Footer/Footer";

export interface HomeProps {
  candyMachineId: anchor.web3.PublicKey;
  config: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  treasury: anchor.web3.PublicKey;
  txTimeout: number;
}

const Home = (props: HomeProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Wrapper>
      <Background />

      <Nav />
      <Intro
        candyMachineId={props.candyMachineId}
        config={props.config}
        connection={props.connection}
        startDate={props.startDate}
        treasury={props.treasury}
        txTimeout={props.txTimeout}
      />
      <InfoOne />
      <Carousel />
      <InfoTwo />

      <InfoThree />
      <InfoFour />
      <InfoFive />
      <Roadmap />
      <Generate />
      <Faq />
      <Footer />
    </Wrapper>
  );
};

export default Home;

const Wrapper = styled.div`
  .background {
  }

  .lottie-wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
  }

  overflow-x: hidden;
`;
